
export const ACCESSCODE="accessCode";
export const ACCESSCODEPURCH="accessCodePurch";
export const ACCESSLOGIN="accessLogin";
export const ACCESSLOGINPURCH="accessLoginPurch";

export function hasPanel(type) {
  return type != "0x84739";
}

export function getPanelType(type) {
  let typesParts = type.split('xx');
  let data = {
    ecomm: typesParts.length > 1,
    wcdata: typesParts.length > 1 ? typesParts[1] : false,
    streamType: 'free',
  };
  switch (typesParts[0]) {
    case "0x88479":
      data.streamType = data.ecomm ? ACCESSCODEPURCH : ACCESSCODE;
      break;
    case "0x28374":
      data.streamType = data.ecomm ? ACCESSLOGINPURCH : ACCESSLOGIN;
      break;
  }
  return data;
}
